module.exports = require("@mui/icons-material/CenterFocusWeak");